import { createFileRoute } from '@tanstack/react-router';
import { Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/employees/')({
  component: EmployeesIndexRoute,
});

function EmployeesIndexRoute() {
  return <Outlet />;
} 